import {Injector} from '@angular/core';
import {environment} from '../../environments/environment';
import {KeycloakAuthService} from './keycloak-auth.service';
import {CognitoAuthService} from './cognito-auth.service';
import {AuthService} from './auth.service';
import {KeycloakService} from 'keycloak-angular';
import {Amplify} from 'aws-amplify';


export function initKeycloak(kc: KeycloakService) {

  return (): Promise<boolean> =>
    kc.init({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
      },
    });
}

export function initAmplifyCognito() {
  return (): void => {
    const awsConfig = {
      userPoolId: environment.aws.userPoolId,
      userPoolClientId: environment.aws.userPoolWebClientId,
    };

    Amplify.configure({
      Auth: {
        Cognito: awsConfig,
      },
    });
  };
}

export function authServiceFactory(injector: Injector): AuthService {
  return environment.IDENTITY_PROVIDER === 'cognito'
    ? injector.get(CognitoAuthService)
    : injector.get(KeycloakAuthService);
}

export const AUTH_PROVIDER = {
  provide: AuthService,
  useFactory: authServiceFactory,
  deps: [Injector],
};
